import React, { useState, useEffect, useRef } from "react";
import Header from "../Header";
import Footer from "../Footer";
import { API_URL, BASE_URL } from "../Config";
import config from "../common/Config";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import $ from "jquery";
import "datatables.net-bs5";
import Swal from "sweetalert2";
import CommonDatePicker from "../datepicker/CommonDatePicker";
import { format } from "date-fns";
import { setTableWidths, getTableWidths } from "../../data/postAPi";
import "../../components/css/custom-filter.css";

const Proforma = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [newSales, setNewSales] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const salesOrderRef = useRef(null);
  const orderIdRef = useRef(null);
  const reasonRef = useRef(null);
  const accessToken = localStorage.getItem("accessToken");
  const roleID = localStorage.getItem("roleID");
  const [salesDates, setSalesDates] = useState([null, null]);
  const [colWidths, setColWidths] = useState([60, 120, 120, 200, 150, 150, 150, 150, 120]);
  const userId = localStorage.getItem("userId");
  const tableName = "proformaTable";
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  const debouncedSetTableWidths = useRef(
    debounce((userId, tableName, widths) => {
      setTableWidths(userId, tableName, widths);
    }, 500)
  ).current;
  const startResizing = (index, e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = colWidths[index];
    const onMouseMove = (moveEvent) => {
      const newWidth = Math.max(50, startWidth + moveEvent.clientX - startX);
      setColWidths((widths) => {
        const updated = [...widths];
        updated[index] = newWidth;
        debouncedSetTableWidths(userId, tableName, updated);
        return updated;
      });
    };
    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };
  useEffect(() => {
    async function fetchWidths() {
      try {
        const res = await getTableWidths(userId, tableName);
        if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
          setColWidths(res.data.widths);
        } else {
          setColWidths([60, 120, 120, 200, 150, 150, 150, 150, 120]);
        }
      } catch (e) {
        setColWidths([60, 120, 120, 200, 150, 150, 150, 150, 120]);
      }
    }
    fetchWidths();
  }, []);

  useEffect(() => {
    fetchData();
  }, [fromDate, toDate]);

  const handleSubmitDates = (value) => {
   
    const [startDate, endDate] = value;
    console.log("startDate", value);
    let formattedStartDate = "";
    let formattedEndDate = "";

    if (startDate) {
      const start = typeof startDate === 'string' ? new Date(startDate) : startDate;
      formattedStartDate = format(start, "MM/dd/yyyy");
    }

    if (endDate) {
      const end = typeof endDate === 'string' ? new Date(endDate) : endDate;
      formattedEndDate = format(end, "MM/dd/yyyy");
    }

    console.log("Submitting dates:", { formattedStartDate, formattedEndDate }); // Debug log
    fetchData(formattedStartDate, formattedEndDate);
  };

  const fetchData = (startDate, endDate) => {
    const $table = $(salesOrderRef.current);
    if (!$table.length) return;

    // Destroy existing DataTable instance to prevent reinitialization issues
    if ($.fn.DataTable.isDataTable($table)) {
      $table.DataTable().destroy();
    }

    // Initialize DataTable
    $table.DataTable({
      processing: true,
      serverSide: true,
      responsive: false,
      ordering: false,
      autoWidth: false,
      responsive: false,
      pageLength: 50,
      ajax: {
        url: `${config.API_URL}/proforma/invoice`,
        type: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        data: function (d) {
          return {
            ...d,
            draw: d.draw,
            start: d.start,
            length: d.length,
            searchByFromdate: startDate || "",
            searchByTodate: endDate || ""
          };
        },
        dataSrc: function (json) {
          if (json?.data && Array.isArray(json.data)) {
            setNewSales(json.data);
            return json.data;
          }
          return [];
        },
        error: function (xhr) {
          console.error("DataTable AJAX error:", xhr.responseText);
        },
      },
      language: {
        paginate: {
          first: "First",
          last: "Last",
          next: "Next",
          previous: "Previous",
        },
        search: "Search:",
      },
      columns: [
        {
          data: null,
          width: colWidths[0] + 'px',
          orderable: false,
          className: "text-center",
          render: function (data, type, row, meta) {
            // Do not render checkbox if invoice_total is 0 or falsy
            if (!row.invoice_total || Number(row.invoice_total) === 0) {
              return '';
            }
            return `<label class="checkbox">
              <input type="checkbox" class="order-checkbox dataTableCheckboxNew" data-id="${row.id}" />
              <span class="default"></span>
            </label>`;
          }
        },
        { data: "invoice_date", width: colWidths[1] + 'px', className: "text-center" },
        {
          data: "reference_no",
          width: colWidths[2] + 'px',
          className: "text-center",
          render: (data, type, row) => {
            const NotAllowed = roleID === '20';
            const ref = row.reference_no;
           // const url = `${config.BASE_URL}/edit/proforma/${row.id}`;
            const url = accessToken === 'sdm'
              ? `${config.BASE_URL}/edit/proforma_sdm/${row.id}`
              : `${config.BASE_URL}/edit/proforma/${row.id}`;
            //console.log("Role ID:", isHoldOrNotAllowed);
            return NotAllowed
              ? `<label style="color: #f14240;">${ref}</label>`
              : `<a href="${url}">${ref}</a>`;
          }
        },
        { data: "customer", width: colWidths[3] + 'px' },
        { data: "route_number", width: colWidths[4] + 'px', className: "text-center" },
        { data: "deliverydate", width: colWidths[5] + 'px', className: "text-center" },
        {
          data: null,
          width: colWidths[6] + 'px',
          render: function (data, type, row) {
            const invoiceTotal = row.invoice_total ? row.invoice_total : "";
            return `<span>${invoiceTotal}</span>`;
          },
        },
        { data: "sale_status", width: colWidths[7] + 'px', className: "text-center" },
        {
          data: null,
          width: colWidths[8] + 'px',
          render: function (data, type, row) {
            return `<div>
              <a class="deductionbtn" data-action="reject" data-order='${encodeURIComponent(
              JSON.stringify(data)
            )}' title="Reject Order"><i class="bi bi-ban"></i></a>
 <!-- <a class="applybtn" href="../trip_summary/print/${row.id
              }" title="Print Invoice"><i class="bi bi-printer"></i></a>-->
            </div>`;
          },
        },
      ],
      createdRow: function (row, data, dataIndex) {
        // Add a data-id attribute to each row based on the row's id
        $(row).attr("data-id", data.id);
      },
      columnDefs: [{ targets: [], sortable: true }]
    });

    // Handle clicks for actions
    $("#proformaTable").on("click", 'a[data-action="reject"]', function (e) {
      e.preventDefault();
      const orderData = $(this).data("order");
      try {
        const order = JSON.parse(decodeURIComponent(orderData));
        setSelectedOrder(order);
        setShowRejectModal(true);
      } catch (error) {
        console.error("Error parsing order data:", error);
      }
    });

    // Cleanup on unmount
    return () => {
      if ($.fn.DataTable.isDataTable($table)) {
        $table.DataTable().destroy();
      }
    };
  };

  useEffect(() => {
    const addResizerListeners = () => {
      const resizers = document.querySelectorAll('#proformaTable .th-resizer');
      resizers.forEach((resizer, index) => {
        const handleMouseDown = (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          startResizing(index, e);
        };
        resizer.addEventListener('mousedown', handleMouseDown);
        resizer._resizerHandler = handleMouseDown;
      });
    };
    const timeoutId = setTimeout(() => {
      addResizerListeners();
      $('#proformaTable thead th').each(function (idx) {
        $(this).css('width', colWidths[idx] + 'px');
      });
    }, 100);
    return () => {
      clearTimeout(timeoutId);
      const resizers = document.querySelectorAll('#proformaTable .th-resizer');
      resizers.forEach((resizer) => {
        if (resizer._resizerHandler) {
          resizer.removeEventListener('mousedown', resizer._resizerHandler);
        }
      });
      const $table = $('#proformaTable');
      // if ($.fn.DataTable.isDataTable($table)) {
      //   $table.DataTable().destroy();
      // }
    };
  }, [newSales]);
  // console.log(colWidths);

  const resizerStyles = `
    .th-resizer:hover {
      background-color: rgba(0, 0, 0, 0.3) !important;
    }
    .resizable-header {
      position: relative;
      user-select: none;
    }
  `;
  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.textContent = resizerStyles;
    document.head.appendChild(styleSheet);
    return () => {
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchData();
  };

  const updateReject = async (event) => {
    event.preventDefault();

    if (!orderIdRef.current || !reasonRef.current) {
      console.error("Required form elements are missing");
      alert("Required form elements are missing. Please try again.");
      return;
    }

    const orderId = orderIdRef.current.value;
    const reason = reasonRef.current.value;

    const formData = new FormData();
    formData.append("status", "Reject");
    formData.append("reason_note", reason);
    formData.append("id", orderId);
    formData.append("new-sales", 'No');
    const accessToken = localStorage.getItem("accessToken");

    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }

    try {
      const response = await fetch(`${config.API_URL}/ws-update-status`, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `HTTP error! Status: ${response.status}. Error: ${errorText}`
        );
      }

      const data = await response.json();
      console.log("API Response:", data);

      Swal.fire({
        title: "Success!",
        text: "Order rejected successfully.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      }).then(() => {
        window.location.href = config.BASE_URL + "/picking/proforma/";
      });
    } catch (error) {
      console.error("Error rejecting order:", error);
      alert("Error rejecting order. Please check the console for details.");
    }

    setShowRejectModal(false);
  };



  $("#proformaTable").off("change", "#select-all-checkbox").on("change", "#select-all-checkbox", function () {
    const isChecked = $(this).prop("checked");
    $("#proformaTable tbody .order-checkbox").prop("checked", isChecked).trigger("change");
  });


  $("#proformaTable").off("change", ".order-checkbox").on("change", ".order-checkbox", function () {
    const total = $("#proformaTable tbody .order-checkbox").length;
    const checked = $("#proformaTable tbody .order-checkbox:checked").length;
    $("#select-all-checkbox").prop("checked", total === checked);
    setSelectedCount(checked);
  });


  const handleConfirmOrders = async () => {
    const selectedIds = [];
    $("#proformaTable tbody .order-checkbox:checked").each(function () {
      selectedIds.push($(this).data("id"));
    });

    if (selectedIds.length === 0) {
      Swal.fire('Error', 'Please select at least one order.', 'error');
      return;
    }

    try {
      const response = await fetch(`${config.API_URL}/confirm-orders`, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ order_ids: selectedIds }),
      });

      if (!response.ok) throw new Error('API error');
      await response.json();

      Swal.fire('Success', 'Orders confirmed!', 'success');
      $("#select-all-checkbox").prop("checked", false); // uncheck header
      setSelectedCount(0); // reset selected count
      fetchData(); // reload table
    } catch (err) {
      Swal.fire('Error', 'Failed to confirm orders.', 'error');
    }
  };



  return (
    <div>
      <Header />
      <nav className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <a href="#">
                <i className="fa fa-home"></i>
              </a>
              <span className="last-crumb">Confirm Picking</span>
            </div>
          </div>
        </div>
      </nav>

      {showRejectModal && (
        <div
          className="modal fade show d-block"
          id="reject-order"
          tabIndex="-1"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Reject Order</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowRejectModal(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                {selectedOrder && (
                  <div className="rejectorder-popup">
                    <form id="rejectForm">
                      <h4>Proforma Invoice Details</h4>
                      <table className="table table-bordered resizable">
                        <tbody>
                          <tr>
                            <td>Order Id</td>
                            <td>{selectedOrder.reference_no}</td>
                          </tr>
                          <tr>
                            <td>Customer (A/C)</td>
                            <td>{selectedOrder.customer}</td>
                          </tr>
                          <tr>
                            <td>Order Amount</td>
                            <td>{selectedOrder.invoice_total}</td>
                          </tr>
                          <tr>
                            <td>Previous Dues</td>
                            <td>{selectedOrder.previous_dues || "N/A"}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div className="form-group">
                        <label className="col-form-label">Reason Note</label>
                        <textarea
                          id="reason"
                          name="reason"
                          ref={reasonRef}
                        ></textarea>
                      </div>
                      <input
                        type="hidden"
                        name="order_id"
                        id="order_id"
                        ref={orderIdRef}
                        value={selectedOrder.id}
                      />
                      <button
                        type="button"
                        onClick={updateReject}
                        className="updatebtn left updateReject"
                      >
                        Update
                      </button>
                    </form>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="main-container position-relative">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div>
                <div className="row">
                  <div className="proforma-filter-row col-md-12 row" >
                    <div className="col-md-5 col-lg-5 col-sm-5">
                      <CommonDatePicker
                        value={salesDates}
                        onChange={(value) => {
                          setSalesDates(value);
                          console.log("value", value);
                          if (value && value[0] && value[1]) {
                            setTimeout(() => {
                              handleSubmitDates(value);
                            }, 100);
                          }
                        }}
                        style={{ width: '100%' }}
                      />

                    </div>
                    <div className="col-md-3 col-lg-3 col-sm-3">
                      <button onClick={handleConfirmOrders} className="multisubmit">
                        {selectedCount > 1 ? "Bulk Confirm" : "Confirm"}
                      </button>
                    </div>
                  </div>
                  <div className="dashboard proforma-table">
                    <div className="verical-scrl-wrapper proforma" id="style-3">
                      <table
                        className="table table-bordered dataTable resizable resizable-columns"
                        id="proformaTable"
                        ref={salesOrderRef}
                      >
                        <thead>
                          <tr>
                            <th className="text-center">
                              <input type="checkbox" id="select-all-checkbox" />
                            </th>
                            {[
                              "Invoice Date",
                              "Order Id",
                              "Customers (Account No)",
                              "Route",
                              "Delivery Date",
                              "Invoice Amt",
                              "Status",
                              "Action"
                            ].map((header, idx) => (
                              <th
                                key={header}
                                className="resizable-header"
                                style={{
                                  width: colWidths[idx],
                                  minWidth: 50,
                                  position: "relative",
                                  padding: "8px"
                                }}
                              >
                                {header}
                                {idx < colWidths.length - 1 && (
                                  <div
                                    className="th-resizer"
                                    data-column-index={idx}
                                    title="Drag to resize column"
                                    style={{
                                      position: 'absolute',
                                      right: '-2px',
                                      top: 0,
                                      width: '5px',
                                      height: '100%',
                                      cursor: 'col-resize',
                                      zIndex: 999,
                                      userSelect: 'none'
                                    }}
                                  />
                                )}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody></tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Proforma;
